import * as req from 'api/actions';
import * as c from './constant';

export const getDiscountPenaltyList = (payload, callback) =>
  req.item(
    c.GET_DISCOUNT_PENALTY_LIST,
    'api/v1/bpls/administrator/settings',
    payload,
    callback
  );

export const updateDiscountPenalty = (payload, callback) =>
  req.create(
    c.UPDATE_DISCOUNT_PENALTY,
    `api/v1/bpls/administrator/settings`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );


export const getFeeCodes = (payload, callback) => 
req.list(
  c.GET_FEE_CODES,
  '/api/v1/bpls/administrator/common/fee_codes',
  payload,
  callback,
)

export const getFeeSettings = (payload, callback) => 
req.list(
  c.GET_FEE_SETTINGS,
  '/api/v1/bpls/administrator/fee_settings',
  payload,
  callback,
)

export const updateFeeSettings = (payload, callback) => 
  req.create(
    c.UPDATE_FEE_SETTINGS,
    '/api/v1/bpls/administrator/fee_settings',
    payload,
    callback,
  );